import * as React from 'react';
import { DropdownField as DropdownFieldComponent, IDropdownFieldProps } from '@cian/components';

import * as styles from './styles.css';

export const DropdownField: React.StatelessComponent<IDropdownFieldProps> = props => (
  <DropdownFieldComponent buttonStyle={styles['dropdown-field']} {...props} />
);
